import { Alert } from '@cast/design-system';

export const AggressiveModeIgnorePvPodsAlert = () => {
  return (
    <Alert
      color="warning"
      icon="warning"
      size="sm"
      testId="ignore-pv-pods-alert"
    >
      Includes pods with local persistent volumes. Local PV data is destroyed
      when the node is deleted. You&apos;ll be asked to confirm before saving.
    </Alert>
  );
};
